import { Controller } from '@hotwired/stimulus';
import { ProcessingStatusPoller } from '../processing_status_poller.mjs';

export default class extends Controller {
  static values = { url: String };

  connect() {
    this.poller = new ProcessingStatusPoller({
      url: this.urlValue,
      fetchStatus: (url) => fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }),
      onTerminal: () => window.Turbo.visit(window.location.href, { action: 'replace' }),
    });
    this.poller.start();
  }

  disconnect() {
    this.poller?.stop();
  }
}
